import { supabase } from '@/integrations/supabase/client';

const OPENWEATHER_API_KEY = import.meta.env.VITE_OPENWEATHER_API_KEY;

if (!OPENWEATHER_API_KEY) {
  console.error('OpenWeatherMap API key is not set in environment variables');
}

export interface WeatherData {
  temperature: number;
  humidity: number;
  windSpeed: number;
  precipitation: number;
  description: string;
  icon: string;
}

export const fetchWeatherData = async (regionId: string): Promise<WeatherData | null> => {
  try {
    console.log('Fetching weather data for region:', regionId);
    
    // First, get the region's coordinates from Supabase
    const { data: regionData, error: regionError } = await supabase
      .from('regions')
      .select('coordinates')
      .eq('id', regionId)
      .single();

    if (regionError) {
      console.error('Error fetching region coordinates:', regionError);
      throw regionError;
    }

    if (!regionData) {
      console.error('Region not found');
      return null;
    }

    const [latitude, longitude] = regionData.coordinates;
    console.log('Region coordinates:', { latitude, longitude });

    if (!latitude || !longitude) {
      console.error('Region missing coordinates');
      return null;
    }

    // Fetch weather data from OpenWeatherMap API
    const response = await fetch(
      `https://api.openweathermap.org/data/2.5/weather?lat=${latitude}&lon=${longitude}&units=metric&appid=${OPENWEATHER_API_KEY}`
    );

    if (!response.ok) {
      const errorData = await response.json();
      console.error('OpenWeatherMap API error:', errorData);
      throw new Error(`OpenWeatherMap API error: ${errorData.message}`);
    }

    const data = await response.json();
    console.log('OpenWeatherMap API response:', data);

    return {
      temperature: Math.round(data.main.temp),
      humidity: data.main.humidity,
      windSpeed: Math.round(data.wind.speed * 3.6), // Convert m/s to km/h
      precipitation: data.rain ? data.rain['1h'] || 0 : 0,
      description: data.weather[0].description,
      icon: data.weather[0].icon
    };
  } catch (error) {
    console.error('Error fetching weather data:', error);
    return null;
  }
}; 